import { getAccountPropertiesAsync } from './getAccountPropertiesAsync'

export const getAccountEmailAsync = async (refresh = false) => {
  try {
    const { email } = await getAccountPropertiesAsync(refresh)
    return email
  } catch (err) {
    return null
  }
}
